var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingIndicator"},[(_vm.loaderType === 'clip')?_c('ClipLoader',{attrs:{"color":_vm.loaderColor,"size":!_vm.size ? undefined : _vm.size,"size-unit":"px"}}):_vm._e(),(_vm.loaderType === 'bar')?_c('BarLoader',{attrs:{"color":_vm.loaderColor,"size":!_vm.size ? undefined : _vm.size,"size-unit":"px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }